export enum ControlledDocumentRequestTypeEnum {
  NewDocument = 'New Document',
  NewPreApprovedDocument = 'New Pre Approved Document',
  UpdateDocument = 'Update Document',
  RetireDocument = 'Retire Document',
}
